module.exports = __webpack_public_path__ + "static/img/Jonty-Faull.c940292.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jonty-Faull.jpg
// module id = 6eo5
// module chunks = 0